export function OWNER_REQUEST(state) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: true
  };
}

export function OWNER_SUCCESS(state, payload) {
  payload.data.data.data.map(item => {
    const newValue = Object.keys(item).map(value => {
      if (item[value] === null) {
        item[value] = "-";
      }
      return item;
    });
    return newValue;
  });
  state;
  state.customers = {
    ...state.customers,
    isLoading: false,
    data: payload.data.data.data,
    count: payload.data.data.totalData
  };
}
export function OWNER_ERROR(state, payload) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function EDIT_CUSTOMER_REQUEST(state) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: true
  };
}
export function EDIT_CUSTOMER_SUCCESS(state) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: false
  };
}
export function EDIT_CUSTOMER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_OWNER_REQUEST(state) {
  state;
  state.customer = {
    ...state.customer,
    isLoading: true
  };
}
export function GET_OWNER_SUCCESS(state, payload) {
  const { customer, customer_address, employee } = payload.data;
  // dummy data customre
  const data = {
    customer: {
      ...customer.data.data
    },
    customerAddress: {
      listAddress: customer_address.data.data.listAddress,
      customerAddress: customer_address.data.data.customerAddress
    },
    owner: employee.data.data.owner,
    employee: employee.data.data.employee
  };
  state;
  state.customer = {
    ...state.customer,
    isLoading: false,
    data: data
  };
}
export function GET_OWNER_ERROR(state, payload) {
  state;
  state.customer = {
    ...state.customer,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_OWNER_REQUEST(state) {
  state;
  state.customer = {
    ...state.customer,
    isLoading: true
  };
}
export function CREATE_OWNER_SUCCESS(state, payload) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: false,
    data: [...state.customers.data, payload.results.data],
    error: false,
    errorMessage: null
  };
}
export function CREATE_OWNER_ERROR(state, payload) {
  state;
  state.customer = {
    ...state.customer,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function EDIT_OWNER_REQUEST(state) {
  state;
  state.customer = {
    ...state.customer,
    isLoading: true
  };
}
export function EDIT_OWNER_SUCCESS(state, payload) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: false,
    data: state.customers.data.map(item => {
      if (item.id === payload.results.data.id) {
        return Object.assign({}, item, payload.results.data);
      }
      return item;
    })
  };
}
export function EDIT_OWNER_ERROR(state, payload) {
  state;
  state.customer = {
    ...state.customer,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function DELETE_OWNER_REQUEST(state) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: true
  };
}
export function DELETE_OWNER_SUCCESS(state, payload) {
  let index = state.customers.data.findIndex(item => item.id == payload.id);
  state.customers.data.splice(index, 1);
  state;
  state.customers = {
    ...state.customers,
    isLoading: false,
    data: state.customers.data
  };
}
export function DELETE_OWNER_ERROR(state, payload) {
  state;
  state.customers = {
    ...state.customers,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_SUBSTORE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function CREATE_SUBSTORE_SUCCESS(state, payload) {
  state;
  state.substores = [...state.subStores, payload.results.data];
  state.isLoading = false;
}
export function CREATE_SUBSTORE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function CREATE_EMPLOYEE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function CREATE_EMPLOYEE_SUCCESS(state, payload) {
  state;
  state.employees = [...state.employees, payload.results.data];
  state.isLoading = false;
}
export function CREATE_EMPLOYEE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
